<button #hubButton [type]="type" [disabled]="disabled || loading" [class]="buttonClasses"
  [ngStyle]="{'background-color': backgroundColor}" (click)="onButtonClick($event)">

    <div *ngIf="badgeValue" class="badge" [ngStyle]="{'background-color': badgeColor}">{{ badgeValue }}</div>
    <div class="spinner-container" *ngIf="loading">
      <daz-icon [name]="'spinner'" [spin]="true" [size]="iconSize" [color]="getIconColor">
      </daz-icon>
    </div>

    <daz-icon *ngIf="icon && iconPosition === 'left' && !loading" [name]="icon" [size]="iconSize"
      [color]="getIconColor">
    </daz-icon>

    <span *ngIf="text && !loading" class="button-text">{{ text }}</span>

    <daz-icon *ngIf="icon && iconPosition === 'right' && !loading" [name]="icon" [size]="iconSize" 
      [color]="getIconColor">
    </daz-icon>
</button>